import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ssp-map-locate-device-button',
  templateUrl: './map-locate-device-button.component.html',
  styleUrls: ['./map-locate-device-button.component.scss', '../../../../../../../../../assets/soti-tooltip.scss'],
})
export class MapLocateDeviceButton {
  @Input()
  locateDeviceInProgress = false;

  @Output()
  locateDevice = new EventEmitter<null>();

  locateDeviceFn() {
    this.locateDevice.emit(null);
  }
}
